import React, { useState } from 'react';
import List from '@material-ui/core/List';
//import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';
import { Icon, makeStyles } from '@material-ui/core';
import CollapseItem from './CollapseItem';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
//import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
    listItems: {
        [theme.breakpoints.up('xs')]: {
            color: '#abacb7',
            textAlign: "left",
            paddingLeft: "6%",
            

        },
        [theme.breakpoints.up('sm')]: {
            color: '#abacb7',
            textAlign: "left",
            paddingLeft: "6%",
            

        },
        [theme.breakpoints.up('md')]: {
            color: '#abacb7',
            textAlign: "left",
            paddingLeft: "3%",
            

        },
        [theme.breakpoints.up('lg')]: {
            color: '#abacb7',
            textAlign: "left",
            paddingLeft: "3%",
            

        },
        [theme.breakpoints.up('xl')]: {
            color: '#abacb7',
            textAlign: "left",
            paddingLeft: "3%",
            
        },

    },
    fontsize: {
        fontSize: 14
    },
    fontsizeSubmenu: {
        fontSize: 14
    },
    listItemsactive: {
        [theme.breakpoints.up('xs')]: {
            color: '#0D0E10',
            textAlign: "left",
            paddingLeft: "6%",
            "&:hover": {
                color: '#0D0E10'
            }
        },
        [theme.breakpoints.up('sm')]: {
            color: '#0D0E10',
            textAlign: "left",
            paddingLeft: "6%",
            "&:hover": {
                color: '#0D0E10'
            }
        },
        [theme.breakpoints.up('md')]: {
            color: '#0D0E10',
            textAlign: "left",
            paddingLeft: "3%",
            "&:hover": {
                color: '#0D0E10'
            }
        },
        [theme.breakpoints.up('lg')]: {
            color: '#0D0E10',
            textAlign: "left",
            paddingLeft: "3%",
            "&:hover": {
                color: '#0D0E10'
            }
        },
        [theme.breakpoints.up('xl')]: {
            color: '#0D0E10',
            textAlign: "left",
            paddingLeft: "3%",
            "&:hover": {
                color: '#0D0E10'
            }
        },

    },
    listItemsdesactive: {
        color: '#abacb7',
        textAlign: "left",
        
    },
    listSubItemsactive: {
        color: theme.palette.type === 'dark' ? '#b98919' : '#312a5c',
        "&:hover": {
            // color: '#000000'
        }
    },
    listSubItemsactivebackground: {
        color: '#abacb7',
        paddingLeft: theme.spacing(4),
        // backgroundColor: "#fff",
        /* position: "absolute",
        left: "15%",
        bottom: "0",
        width: "70%", */
        // borderBottom: "1px solid #FFF",
        "&:hover": {
            // backgroundColor: "#efefef"
        }
    },
    listSubItemsdesactivebackground: {
        paddingLeft: theme.spacing(4),
        // backgroundColor: "#fff",
        borderRadius: 10,
        /* position: "absolute",
        left: "15%",
        bottom: "0",
        width: "70%", */
        // borderBottom: "1px solid #FFF",
        "&:hover": {
            // backgroundColor: "#efefef"
        }
    },
    menudesactive: {
        color: '#abacb7',
        // backgroundColor: "#fff",
        borderRadius: 10,
        /* position: "absolute",
        left: "15%",
        bottom: "0",
        width: "70%", */
        //borderBottom: "3px solid #FFF",
        "&:hover": {
            // backgroundColor: "#efefef",
        }
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    menuactive: {
        color: '#2E2757',
        backgroundColor: '#efefef',
        borderRadius: 10,
        /* position: "absolute",
        left: "15%",
        bottom: "0",
        width: "70%", */
        //borderBottom: "3px solid #FFF",
        "&:hover": {
            backgroundColor: '#706D85'
        },
    },
    logo: {
        color: '#FFFFFF',
        [theme.breakpoints.up('xs')]: {
            width: `100%`,
            height: `100%`
        },
        [theme.breakpoints.up('sm')]: {
            width: `100%`,
            height: `100%`
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: `75%`,
            height: `150%`
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: `75%`,
            height: `150%`
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: `75%`,
            height: `150%`
        },
        // width: '70%',
        // height: '100%'
    },
    icon: {
        color: '#FFFFFF',
        [theme.breakpoints.up('xs')]: {
            width: `20%`,
            heigth: `100%`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `20%`,
            heigth: `100%`,
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: `13%`,
            minWidth: '13%'
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: `13%`,
            minWidth: '13%'
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: `13%`,
            minWidth: '13%'
        },
        // height: '15%'
    },

}));


const MenuItems = props => {
    const { sendData, items, menuselectedsimple, menuCollapseSelected, submenuCollapseSelected, menuselectedcollapse, devices } = props

    const [open, setOpen] = useState(false)

    const classes = useStyles()
    return (
        <div>
            <List style={{ padding: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                {
                    items.map((item) => {
                        const { icon_name_active, text, url, type, state } = item
                        if (type === 'simple' && state === 1) {
                            return <ListItem key={text} button={(isMobile) ? false : true} selected={false} onClick={() => sendData(url, text)} className={(text === menuselectedsimple) ? classes.menuactive : classes.menudesactive}>

                                {
                                    state ?
                                        <div className={classes.icon} >
                                            {/* <img src={(text === menuselectedsimple) ? item.icon_name_active : item.icon_name_inactive} alt="Logo" className={classes.logo} /> */}
                                            <Icon style={{ color: (text === menuselectedsimple ? "#2E2757" : "#abacb7") }}>{icon_name_active}</Icon>
                                        </div>
                                        :
                                        <ListItemIcon>
                                            <Icon>{icon_name_active}</Icon>
                                        </ListItemIcon>
                                }

                                <ListItemText primary={<Typography
                                    component="span"
                                    variant="body2"
                                    className={classes.fontsize}
                                >
                                    {text}
                                </Typography>} className={(text === menuselectedsimple) ? classes.listItemsactive : classes.listItems} />



                            </ListItem>

                        } else if (type === 'collapse' && state ===1) {
                            const { application_submenu } = item
                            if (item.state) {
                                return <CollapseItem svg={item.state} svgRouteNegative={item.icon_name_inactive} svgRoute={item.icon_name_active} 
                                key={text} icon={icon_name_active} text={text} subItems={application_submenu} onSendData={(r, t) => sendData(r, t)} 
                                classes={classes} menuselectedsimple={menuselectedsimple} menuCollapseSelected={menuCollapseSelected} 
                                menuselectedcollapse={menuselectedcollapse} submenuCollapseSelected={(r, t, tf) => submenuCollapseSelected(r, t, tf)} 
                                open={open} setOpen={(s) => setOpen(s)} devices = {devices} />
                            } else {
                                return <CollapseItem key={text} svgRouteNegative={item.icon_name_inactive} icon={icon_name_active} text={text}
                                    subItems={application_submenu} onSendData={(r, t) => sendData(r, t)} classes={classes} menuselectedsimple={menuselectedsimple} menuCollapseSelected={menuCollapseSelected} menuselectedcollapse={menuselectedcollapse} submenuCollapseSelected={(r, t, tf) => submenuCollapseSelected(r, t, tf)} open={open} setOpen={(s) => setOpen(s)} devices = {devices} />
                            }

                        } else { return null }
                    })
                }
            </List>
            {/* <Divider /> */}
            <List>
                {
                    items.map((item) => {
                        const { icon_name_active, text, url, type } = item
                        if (type === 'secondary') {
                            return <ListItem button key={text} onClick={() => sendData(url)} className={(text === menuselectedsimple) ? classes.menuactive : classes.menudesactive}>
                                {
                                    item.state ?
                                        <div className={classes.icon} >
                                            <img src={item.icon_name_active} alt="Logo" className={classes.logo} />
                                        </div>
                                        :
                                        <ListItemIcon>
                                            <Icon>{icon_name_active}</Icon>
                                        </ListItemIcon>
                                }
                                <ListItemText primary={<Typography
                                    component="span"
                                    variant="body2"
                                    className={classes.fontsize}
                                >
                                    {text}
                                </Typography>} />
                            </ListItem>
                        } else { return null }
                    })
                }
            </List>
        </div>
    );
};

MenuItems.propTypes = {
    sendData: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
};

export default MenuItems;